import React, {useEffect} from "react";
import {Outlet} from "react-router-dom";
import {
  Flex,
  Box,
} from "@chakra-ui/react";
import GlobalToaster from "../GlobalToaster/GlobalToaster.tsx";
import GlobalModal from "../GlobalModal/GlobalModal.tsx";
import PricingModal from "../Credits/PricingModal.tsx";
import NotEnoughCreditsModal from "../Credits/NotEnoughCreditsModal.tsx";
import CreditsMigrationBanner from "../Credits/CreditsMigrationBanner.tsx";
import GlobalDrawer from "../GlobalDrawer/GlobalDrawer.tsx";
import LeftSidebarMenu from "../LeftSidebarMenu/LeftSidebarMenu.tsx";
import GlobalHeader from "../GlobalHeader/GlobalHeader";
import useSystemStore from "../../store/useSystemStore.ts";
import {useSeriesStore} from "../../store/useSeriesStore.ts";

const AuthenticatedLayout: React.FC = () => {
  const {supportedCodeLanguages, getSupportedLanguages} = useSystemStore()
  const {seriesNameIdMappingStatus, getSeriesNameIdMapping} = useSeriesStore()

  useEffect(() => {
    if (supportedCodeLanguages.length === 0) {
      getSupportedLanguages().then(() => null).catch(console.error);
    }
  }, [supportedCodeLanguages, getSupportedLanguages]);

  useEffect(() => {
    if (seriesNameIdMappingStatus === 'idle') {
      getSeriesNameIdMapping().then(() => null).catch(console.error);
    }
  }, [seriesNameIdMappingStatus, getSeriesNameIdMapping]);


  return (
    <div className="authenticated-layout">
      <Flex h="100%" w="100%" overflow="hidden">
        <Box as="aside" h="100vh" bg="n.700">
          <LeftSidebarMenu/>
        </Box>
        <Box as="main" flex="1" h="100vh" py={6} pr={6} minH={0}>
          <Box className="bg-n-100 dark:bg-n-600 h-full rounded-2xl px-9 flex flex-col overflow-hidden"
               style={{minHeight: 0}}>
            <CreditsMigrationBanner/>
            <GlobalHeader/>
            <Box className="flex-1 min-h-0 overflow-y-auto pb-2">
              <Outlet/>
            </Box>
          </Box>
        </Box>
        <GlobalToaster/>
        <GlobalModal/>
        <PricingModal/>
        <NotEnoughCreditsModal/>
        <GlobalDrawer/>
      </Flex>
    </div>
  );
};

export default AuthenticatedLayout;